import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { CustomPage } from "src/app/models/custom-page-model";
import { DefaultService } from "src/app/services/default/default.service";
import Swal from "sweetalert2";
import { Location } from "@angular/common";
import { Webflow } from "src/app/utils/webflow";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-passculture-historiques",
  templateUrl: "./passculture-historiques.component.html",
  styleUrls: ["./passculture-historiques.component.scss"],
})
export class PasscultureHistoriquesComponent implements OnInit {
  sub_title: string = "";

  show_add_button: boolean = false;
  show_delete_button: boolean = false;
  show_edit_button: boolean = false;
  custom_page: CustomPage;

  custom_buttons: Array<any> = [
    {
      text: '<i class="fa fa-sync"></i> Actualiser',
      class: "btn btn-xl btn-outline-studiomap",
      action: () => {
        Webflow.myAction(this.router,"/passculture-historiques", {});
      },
    },
  ];

  columns: Array<any> = [
    {
      key: "code",
      type: "text",
      class: "font-weight-bold",
      value: "Code",
      concat_value: "",
      field_relation: "",
    },
    {
      keys: [
        {
          key: "full_name",
          field_relation: "",
          class: "",
        },
        {
          key: "email",
          field_relation: "",
          class: "font-weight-bold",
        },
        {
          key: "phone_number",
          field_relation: "",
          class: "",
        },
      ],
      type: "card",
      value: "Utilisateur",
    },
    {
      key: "studio_name",
      type: "button",
      class: "btn btn-studiomap btn-sm",
      value: "Studio",
      concat_value: "",
      field_relation: "",
      onClick: (value: any) => {
        Webflow.myAction(this.router,"studios/edit/" + value.studio.id, {});
      },
    },
    {
      key: "nbr_hours_text",
      type: "text",
      class: "font-weight-bold",
      value: "Nbr Heurs",
      concat_value: "",
      field_relation: "",
    },
    {
      key: "sms_client_sended",
      type: "check",
      value: "SMS Artiste",
      operation: "boolean",
      yes: '<i class="fa fa-check text-success"></i>',
      no: '<i class="ni ni-fat-remove text-danger fa-lg"></i>',
    },
    {
      key: "sms_gerant_sended",
      type: "check",
      value: "SMS Gérant",
      operation: "boolean",
      yes: '<i class="fa fa-check text-success"></i>',
      no: '<i class="ni ni-fat-remove text-danger fa-lg"></i>',
    },
    {
      key: "createdAt",
      type: "datetime",
      class: "badge badge-info font-weight-bold",
      value: "Date de validation",
      concat_value: "",
      field_relation: "",
      order_by: true,
      order_by_option: "desc",
    },
  ];

  multi_actions: Array<any> = [];

  visible_actions: Array<any> = [];

  invisible_actions: Array<any> = [];

  constructor(
    private defaultService: DefaultService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private location: Location,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      let filters = "&populate=studio";

      this.custom_page = new CustomPage(
        "passculture-historiques",
        "",
        "réservations passculture validées",
        "",
        filters
      );
    });
  }

  redirectTo(uri: string, params: any) {
    this.router
      .navigateByUrl("/", { skipLocationChange: false })
      .then(() => this.router.navigate([uri], { queryParams: params }));
  }

}
